export enum UserRoles {
  EVENTS_READ = 'events.read',
  EVENTS_ADD = 'events.add',
  EVENTS_EDIT = 'events.edit',
  PING = 'ping',
  PING_TEMPLATES_WRITE = 'ping.templates.write',
}
